module.exports = __webpack_public_path__ + "static/media/Logo.6d3ee14b.png";